module.exports = __webpack_public_path__ + "img/logo-home.3331379b.png";